module.exports = __webpack_public_path__ + "img/samsung.4f1826b5.svg";